/**
 * subjectsApi.js
 * --------------
 * API client for Subjects Master using createMasterApiClient.
 * Connects directly to FastAPI backend /subjects/ endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

const subjectsClient = createMasterApiClient('subjects');

export async function listSubjects(params = {}) {
  return await subjectsClient.list(params);
}

export async function getSubjectDetail(subjectId) {
  return await subjectsClient.getById(subjectId);
}

export async function createSubject(payload) {
  return await subjectsClient.create(payload);
}

export async function updateSubject(subjectId, payload) {
  return await subjectsClient.update(subjectId, payload);
}

export async function archiveSubject(subjectId) {
  return await subjectsClient.archive(subjectId);
}

export async function deleteSubject(subjectId) {
  return await subjectsClient.remove(subjectId);
}

export async function getSubjectOptions() {
  return await subjectsClient.getDropdownOptions();
}
